//imports
import { initSwiperOnView } from '../../lib/funnels/functions/v1/html/initSwiperOnView'
import { queryParamsToSession } from '../../lib/funnels/functions/v1/default/queryParamsToSession'

//vendor CSS
import 'swiper/css/bundle'

//Our CSS
import './index.css'
import '../styles/testimonial.css'

const SESSION_ID = 'tdMainFunnel'

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.bbb-logo img').forEach((bbb_logo) => {
    bbb_logo.setAttribute('src', '/media/bbb-full.png')
  })
  queryParamsToSession(SESSION_ID)

  initSwiperOnView('.review-carousel', {
    pagination: { el: '.review-pagination', clickable: true },
    breakpoints: {
      1024: { slidesPerView: 2, spaceBetween: 32 },
      1200: { slidesPerView: 2, spaceBetween: 24 },
    },
    slidesPerView: 1,
    spaceBetween: 32,
  })
})
